<template>
  <b-modal
    id="news-modal"
    class="news-modal"
    ok-only
    ok-title="Schließen"
    ok-variant="info"
    :title="title"
    centered
    size="lg"
    scrollable
  >
    <b-container>
      <b-row>
        <b-col>
          <b-img-lazy
            fluid
            height="400"
            center
            :src="image"
          ></b-img-lazy>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="12">
          <div v-html="news" class="text-block"></div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { sanitizeHtml } from "@/utils/richText";
import { mediaUrl } from "@/utils/media";

export default {
  name: "NewsModal",
  computed: {
    ...mapGetters(["getSelectedNews"]),
    title() {
      if (this.getSelectedNews !== undefined) {
        return this.getSelectedNews.title;
      } else {
        return "";
      }
    },
    image() {
      if (this.getSelectedNews !== undefined) {
        return mediaUrl(this.getSelectedNews.image, "original");
      } else {
        return "";
      }
    },
    news() {
      if (this.getSelectedNews !== undefined) {
        return sanitizeHtml(this.getSelectedNews.descriptionHTML);
      } else {
        return "";
      }
    },
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
</style>
